<div class="container mx-auto p-4" *ngIf="canAccess">

  <!-- Header -->
  <div class="flex items-center mb-6">
    <mat-icon (click)="goBack()" class="cursor-pointer mr-4">arrow_back_ios</mat-icon>
    <h2 class="text-xl font-bold m-0">Confirmar regalo de eSIM</h2>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Contenido principal -->
  <div *ngIf="!loading" class="max-w-2xl mx-auto">

    <!-- Info del usuario destino -->
    <mat-card class="mb-6 bg-blue-50">
      <mat-card-content class="flex items-center gap-4 py-4">
        <mat-icon class="text-blue-600" style="font-size: 32px; width: 32px; height: 32px;">card_giftcard</mat-icon>
        <div>
          <p class="font-bold m-0">Regalando eSIM a:</p>
          <p class="m-0">{{ targetUserName }}</p>
          <p class="text-sm text-gray-500 m-0">{{ targetUserEmail }}</p>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Tarjeta del paquete -->
    <mat-card class="esim-card mb-6">
      <div class="absolute left-0 ml-4 p-2 flex" style="height:fit-content;">
        <div *ngFor="let item of planType.split('-')">
          <img
            width="16px"
            [src]="'./assets/icons/' + (item || 'data') + '_ico.svg'"
            [title]="item || 'data'"
            class="mx-1"
          />
        </div>
      </div>

      <div class="rounded-full bg-white absolute right-0 mr-4 p-2" style="height:fit-content;" *ngIf="countryImg">
        <span class="flag large block content-center">
          <img [src]="countryImg" alt="Flag" class="w-8 h-6 object-cover rounded">
        </span>
      </div>

      <mat-card-header class="mb-4 mt-8 flex justify-center">
        <div class="esim-image-container text-center">
          <img src="https://cdn-dev.zendy.tel/images/Esim/EsimCard@2x.png" alt="eSIM" class="esim-image mx-auto">
          <span class="esim-country-label">{{ country }}</span>
        </div>
      </mat-card-header>

      <mat-card-content class="text-center">
        <h3 class="text-2xl font-bold m-0">{{ country | titlecase }}</h3>
        <p class="text-lg m-1">{{ title }}</p>
        <p class="text-xl text-gray-500 m-0">Operador: {{ operator }}</p>
      </mat-card-content>
    </mat-card>

    <!-- Detalles del paquete -->
    <mat-card class="mb-6">
      <mat-card-header>
        <mat-card-title>Detalles del paquete</mat-card-title>
      </mat-card-header>
      <mat-card-content class="pt-4">
        <div class="grid grid-cols-2 gap-4">
          <div class="flex items-center">
            <mat-icon class="text-red-700 mr-2">swap_horiz</mat-icon>
            <div>
              <p class="text-sm text-gray-500 m-0">Datos</p>
              <p class="font-bold m-0">{{ data }}</p>
            </div>
          </div>

          <div class="flex items-center">
            <mat-icon class="text-red-700 mr-2">date_range</mat-icon>
            <div>
              <p class="text-sm text-gray-500 m-0">Validez</p>
              <p class="font-bold m-0">{{ validity }}</p>
            </div>
          </div>

          <div class="flex items-center">
            <mat-icon class="text-red-700 mr-2">public</mat-icon>
            <div>
              <p class="text-sm text-gray-500 m-0">Cobertura</p>
              <p class="font-bold m-0">{{ country | titlecase }}</p>
            </div>
          </div>

          <div class="flex items-center">
            <mat-icon class="text-red-700 mr-2">sell</mat-icon>
            <div>
              <p class="text-sm text-gray-500 m-0">Precio original</p>
              <p class="font-bold m-0 line-through text-gray-400">{{ price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</p>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Resumen del regalo -->
    <mat-card class="mb-6 bg-green-50 border-2 border-green-500">
      <mat-card-content class="py-4">
        <div class="flex justify-between items-center">
          <div>
            <p class="text-lg font-bold m-0 text-green-700">REGALO</p>
            <p class="text-sm text-green-600 m-0">El usuario recibirá esta eSIM sin coste</p>
          </div>
          <div class="text-right">
            <p class="text-3xl font-bold m-0 text-green-700">0,00 €</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Botón de confirmar -->
    <div class="flex flex-col gap-4">
      <button
        mat-raised-button
        color="primary"
        class="w-full py-3"
        [disabled]="isSubmitting"
        (click)="assignEsim()">
        <mat-icon *ngIf="!isSubmitting" class="mr-2">card_giftcard</mat-icon>
        <mat-spinner *ngIf="isSubmitting" diameter="20" class="inline-block mr-2"></mat-spinner>
        {{ isSubmitting ? 'Asignando...' : 'Confirmar regalo' }}
      </button>

      <button
        mat-stroked-button
        class="w-full"
        [disabled]="isSubmitting"
        (click)="goBack()">
        Cancelar
      </button>
    </div>

  </div>

</div>
